class CopyBuffer  extends HTMLElement {
    constructor() {
      super();
      this.copyBtn = this;
      this.text = this.closest('.shopify-section').querySelector('.text-buffer').textContent;
      this.copyBtn.addEventListener("click", this.copyText.bind(this));
    }
    copyText() {
      navigator.clipboard.writeText(this.text)
      .then(() => {
        this.classList.add('active');
        setTimeout(() => {
            this.classList.remove('active');
        },1000);
        
      })
      .catch(err => console.error(err))
    }
  }
  customElements.define('copy-buffer', CopyBuffer);